/**
 * /chat 라우트 — AI 채팅 (신규 대화)
 *
 * AgentLayout + ChatZone 조합
 * layoutMode 컨텍스트: 'agent-first'
 */

import { createFileRoute } from "@tanstack/react-router";
import { AgentLayout } from "@/agent/layouts/agent-layout";
import { ChatZone } from "@/agent/features/chat/chat-zone";
import { Suspense } from "react";
import { ChatSkeleton } from "@/agent/ui/errors/skeleton-fallback";
import "@/agent/widgets/register-all";

export const Route = createFileRoute("/_protected/chat")({
  beforeLoad: () => ({
    layoutMode: "agent-first" as const,
  }),
  component: ChatPage,
});

function ChatPage() {
  return (
    <AgentLayout initialMode="agent-first">
      <Suspense fallback={<ChatSkeleton className="flex-1" />}>
        {/* key="new" — /chat/:sessionId ↔ /chat 전환 시 ChatZone 완전 remount.
            useState, useRef, useAgentMessages 쿼리가 fresh 초기화됨. */}
        <ChatZone key="new" />
      </Suspense>
    </AgentLayout>
  );
}
